import * as React from 'react';

import { notificationService } from '../api';
import { closeSnackbar, SnackbarKey, useSnackbar } from 'notistack';
import { NotificationListItem, NotificationResourceTypes } from '../types';
import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface Props {}
type Actiondata = {
  uid: string;
  id: string | null;
  type: NotificationResourceTypes | null;
};
type LabelMap = {
  [key in NotificationResourceTypes]: string;
} & { null?: string };

const actionLabelMap: LabelMap = {
  conversation: 'Open conversation',
  review: 'Open review',
  null: 'Mark as read',
};

export const ShowSystemNotification: React.FC<Props> = ({}) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { systemNotificationList, clearSystemNotification } =
    notificationService();

  React.useEffect(() => {
    if (systemNotificationList) {
      systemNotificationList.map(showMessage);
    }
  }, [systemNotificationList]);

  const action =
    ({ uid, id, type }: Actiondata) =>
    (snackbarId: SnackbarKey) => {
      const hasSource = !!(id && type);
      const handleClick = () => {
        clearSystemNotification({ uid });
        if (hasSource) {
          navigate(`/${type}/${id}`);
        }
        closeSnackbar(snackbarId);
      };

      return (
        <>
          <Button onClick={handleClick} size="small">
            {hasSource ? actionLabelMap[type] : 'Mark as read'}
          </Button>
        </>
      );
    };

  const showMessage = (
    {
      subject,
      body,
      resource_uid: id,
      resource_type: type,
      uid,
    }: NotificationListItem,
    index: number,
  ) => {
    return enqueueSnackbar(
      <Stack>
        <strong>{subject}</strong>
        <span>{body}</span>
      </Stack>,
      {
        variant: 'info',
        action: action({ uid, id, type }),
        autoHideDuration: 12000 + index * 1000,
      },
    );
  };

  return null;
};
